// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { AjaxSubmit: submitType } = SubmitTypes
const { AccountError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'fmo:password-protect',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    submit: {},
    error: true
  }
}

// Component
export default {
  name: 'FomoPasswordForm',
  methods: {
    async transformData(data) {
      const component = this.$el
      const datasource = component.querySelector('.datasource').value
      const promocode = component.querySelector('.promocode').value
      data.datasource = datasource
      data.promocode = promocode
      return data
    },
  },
  mixins: [
    Base(options),
  ],
}